import { Component, inject } from '@angular/core';
import { Hero } from '../../share/hero/hero';
import { RouterLink } from '@angular/router';
import { JobsService } from '../../services/jobs/jobs.service';

@Component({
  selector: 'app-traineeship',
  imports: [Hero, RouterLink],
  templateUrl: './traineeship.html',
  styleUrl: './traineeship.scss',
})
export class Traineeship {
  private readonly jobsServices = inject(JobsService);
  readonly traineeships = this.jobsServices.traineeships;
}
